module.exports = __webpack_public_path__ + "static/media/goat-bleating.bdd8a307.gif";